import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

import TimeDialog from '../../shared/components/time-dialog';

/**
 * <Approve />
 * Approve button for timesheet
 */
export default class Approve extends Component {
  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    forDashboard: PropTypes.bool.isRequired,
    mobile: PropTypes.bool.isRequired,
    onApprove: PropTypes.func.isRequired,
    timesheet: PropTypes.object.isRequired
  };

  state = {
    isDialogOpen: false
  };

  _onCloseDialog() {
    const isDialogOpen = false;
    this.setState({isDialogOpen});
  }

  _onOpenDialog() {
    const isDialogOpen = true;
    this.setState({isDialogOpen});
  }

  _onSave(dates) {
    this.props.onApprove(dates);
    this.setState({isDialogOpen: false});
  }

  render() {
    const {disabled, forDashboard, mobile, timesheet} = this.props;

    const cls = classNames('btn timesheet--submit', {
      'actions-sub-button': forDashboard || mobile,
      'desktop-control': !mobile
    });

    const totals = timesheet.totals.map(total => {
      let message;
      if (total.AllPosted) {
        message = 'Already Posted';
      } else if (total.AllApproved) {
        message = 'Already Approved';
      } else if (!total.AllSubmitted) {
        message = 'Not Yet Submitted';
      } else if (total.Date > Date.now()) {
        message = 'Future Date';
      }

      return {
        ...total,
        Message: message,
        Disabled:
          total.Date > Date.now() ||
          total.AllApproved ||
          total.AllPosted ||
          !total.AllSubmitted
      };
    });

    return (
      <div>
        <button
          className={cls}
          disabled={disabled}
          onClick={() => this._onOpenDialog()}>
          <i className="fa fa-lg fa-check-circle-o" aria-hidden="true" />
          Approve
        </button>
        {this.state.isDialogOpen && (
          <TimeDialog
            heading="By approving this timesheet, you agree that it is complete and accurate."
            onClose={() => this._onCloseDialog()}
            onSave={dates => this._onSave(dates)}
            totals={totals}
            isApprove={true}
            title={`Approve Selected Days for ${timesheet.EmployeeName}`}
          />
        )}
      </div>
    );
  }
}
